import { useEffect, useRef } from 'react';
import { warningSound } from './notify';
import { soundEnabled } from './sound';

/** On the viewer's own turn, the warning beeps once when `remainingMs` first drops below 5 s; a fresh clock (≥ 5 s) or the turn passing re-arms it. */
export function useClockWarning(remainingMs: number | null, isMyTurn: boolean): void {
  const warned = useRef(false);
  useEffect(() => {
    if (!isMyTurn || remainingMs === null || remainingMs >= 5_000) { warned.current = false; return; }
    if (warned.current) return;
    warned.current = true;
    if (soundEnabled()) warningSound();
  }, [remainingMs, isMyTurn]);
}
